module.exports = __webpack_public_path__ + "static/media/logo-1@2x.f3d0157a.png";